import { get } from './APIHelper';

export const getUpcomingGames = async sport => {
  return get(`proxy/api/v1/games/upcoming?sport=${sport}`);
};

export const getKeyFactors = async sport => {
  return get(`proxy/api/v1/keyfactors?sport=${sport}`);
};

export const getPitcherVsOpponentGames = async (sport, pitcherFirstName, pitcherLastName, opponentTeam, limit = 10) => {
  return get(
    `proxy/api/v1/games/pitcher-opponent?sport=${sport}&pitcherFirstName=${encodeURIComponent(pitcherFirstName)}&pitcherLastName=${encodeURIComponent(pitcherLastName)}&opponentTeam=${encodeURIComponent(opponentTeam)}&limit=${limit}`,
  );
};

export const getRosterByTeam = async (sport, teamId) => {
  return get(`proxy/api/v1/rosters/team?sport=${sport}&teamId=${encodeURIComponent(teamId)}`);
};

